export default __webpack_public_path__ + "static/icon-12-6-913028ad37b9055929d2d9c357aad937.png";